export default {
  DANGER: 'DANGER',
  DARK: 'DARK',
  GREY: 'GREY',
  // Modern semantic variants (redesign). peach = primary, dark teal = secondary, red = destructive.
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  DESTRUCTIVE: 'DESTRUCTIVE',
  OUTLINE: 'OUTLINE',
};
